import { Box, Pagination, Theme, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { paginationLayoutSx, paginationSx } from "./CustomTable.styles";

interface CustomProps {
  count: number;
  shape: "rounded" | "circular";
  onPageChange: Function;
  onRowsPerPageChange?: Function;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  showJumpToPageNumber?: boolean;
  jumpToPageNumber?: number;
  setJumpToPageNumber?: Function;
  handleOnChangePageInput?: Function;
}

/**
 * Page control under a `CustomTable`. Carries no styling of its own — the
 * look lives in `CustomTable.styles` so the table and its pagination re-skin
 * together from one place.
 */
const CustomPagination = (props: CustomProps) => {
  const theme = useTheme();
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));

  const count = Math.ceil(props.count / props.rowsPerPage);

  return (
    <Box sx={paginationLayoutSx}>
      <Pagination
        page={props.page}
        count={count}
        shape={props.shape}
        siblingCount={1}
        boundaryCount={1}
        onChange={(event, page: number) => {
          props.onPageChange(event, page);
        }}
        size={smUp ? "medium" : "small"}
        sx={paginationSx(theme)}
      />
    </Box>
  );
};

export default CustomPagination;
